const GITLAB_HOST = 'gitlab.lechun.cc'
const GITLAB_WEB_URL = `https://${GITLAB_HOST}`

function formatDate(value) {
    if (!value) return '-'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return String(value)
    const pad = (num) => (num < 10 ? `0${num}` : String(num))
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export function buildVibeGitlabCodexPrompt(summary = {}) {
    const username = summary.gitlabUsername || '-'
    const email = summary.gitlabEmail || '-'
    const password = summary.gitlabPassword || '-'
    const token = summary.gitlabAccessToken || '-'
    const expiresAt = formatDate(summary.gitlabAccessTokenExpiresAt)

    return `你现在要帮我完成公司 VibeCoding 空间本机开发环境初始化。

公司代码空间信息如下：

- 代码空间 Web: ${GITLAB_WEB_URL}
- 服务 Host: ${GITLAB_HOST}
- 空间账号: ${username}
- 公司邮箱: ${email}
- 初始密码: ${password}
- API AccessToken: ${token}
- AccessToken 过期日期: ${expiresAt}

安全要求：

1. 不要在最终回复里输出初始密码、AccessToken、SSH 私钥。
2. 不要把初始密码、AccessToken、SSH 私钥写入任何项目仓库。
3. 不要把初始密码、AccessToken 写入 shell 脚本文件。
4. 可以把 AccessToken 配置到本机 glab 凭据中，供后续使用。
5. 如果命令输出里包含 token，请只说明“已配置”，不要复述原文。

请你直接在我的本机完成以下事情：

1. 检查是否已安装 glab；如果没有安装，macOS 优先用 \`brew install glab\`。
2. 使用上面的 AccessToken 登录 \`${GITLAB_HOST}\`，优先使用 \`glab auth login --hostname ${GITLAB_HOST} --git-protocol ssh --api-protocol https --stdin\`。
3. 创建或复用 SSH key：
   - key 路径：\`~/.ssh/id_ed25519_lechun_gitlab\`
   - 类型：ed25519
   - comment：\`${email} ${GITLAB_HOST}\`
4. 将公钥上传到我的公司代码空间账号：
   - title：\`$(hostname)-lechun-gitlab-$(date +%F)\`
   - usage type：auth
   - 如果 key 已存在，不要重复上传，直接继续
5. 配置 \`~/.ssh/config\`，让 \`${GITLAB_HOST}\` 默认使用这个 key。
6. 把 \`${GITLAB_HOST}\` 写入 \`known_hosts\`，避免首次 SSH 交互卡住。
7. 验证：
   - \`glab auth status --hostname ${GITLAB_HOST}\`
   - \`glab api user\`
   - \`glab ssh-key list --hostname ${GITLAB_HOST}\`
   - \`ssh -T git@${GITLAB_HOST}\`

参考命令可以按下面执行，但你要根据我本机实际情况调整：

\`\`\`bash
set +x

GITLAB_HOST="${GITLAB_HOST}"
GITLAB_TOKEN="${token}"
GITLAB_EMAIL="${email}"
SSH_KEY="$HOME/.ssh/id_ed25519_lechun_gitlab"

if ! command -v glab >/dev/null 2>&1; then
  if command -v brew >/dev/null 2>&1; then
    brew install glab
  else
    echo "glab 未安装，且当前环境没有 brew。请先安装 glab 后继续。"
    exit 1
  fi
fi

printf '%s\\n' "$GITLAB_TOKEN" | glab auth login \\
  --hostname "$GITLAB_HOST" \\
  --git-protocol ssh \\
  --api-protocol https \\
  --stdin

mkdir -p "$HOME/.ssh"
chmod 700 "$HOME/.ssh"

if [ ! -f "$SSH_KEY" ]; then
  ssh-keygen -t ed25519 \\
    -C "$GITLAB_EMAIL $GITLAB_HOST" \\
    -f "$SSH_KEY" \\
    -N ""
fi

chmod 600 "$SSH_KEY"
chmod 644 "$SSH_KEY.pub"

KEY_TITLE="$(hostname)-lechun-gitlab-$(date +%F)"
if ! glab ssh-key list --hostname "$GITLAB_HOST" | grep -Fq "$(awk '{print $2}' "$SSH_KEY.pub")"; then
  glab ssh-key add "$SSH_KEY.pub" \\
    --hostname "$GITLAB_HOST" \\
    --title "$KEY_TITLE" \\
    --usage-type auth
fi

touch "$HOME/.ssh/config"
chmod 600 "$HOME/.ssh/config"

if ! grep -q '^Host gitlab.lechun.cc$' "$HOME/.ssh/config"; then
  cat >> "$HOME/.ssh/config" <<'EOF'

Host gitlab.lechun.cc
  HostName gitlab.lechun.cc
  User git
  IdentityFile ~/.ssh/id_ed25519_lechun_gitlab
  IdentitiesOnly yes
EOF
fi

ssh-keyscan -H "$GITLAB_HOST" >> "$HOME/.ssh/known_hosts" 2>/dev/null || true
sort -u "$HOME/.ssh/known_hosts" -o "$HOME/.ssh/known_hosts"
chmod 600 "$HOME/.ssh/known_hosts"

glab auth status --hostname "$GITLAB_HOST"
glab api user
glab ssh-key list --hostname "$GITLAB_HOST"
ssh -T "git@$GITLAB_HOST"

unset GITLAB_TOKEN
set -x 2>/dev/null || true
\`\`\`

完成后请只告诉我：

- glab 是否登录成功
- SSH key 是否已上传
- \`ssh -T git@${GITLAB_HOST}\` 是否返回 Welcome
- 如果失败，给出失败命令和脱敏后的错误信息`
}
